import { Box, CircularProgress, Typography } from '@mui/material'

/**
 * Loading Component
 */
const Loading = ({
    size = 40,
    message = 'Loading...',
    fullScreen = false,
    color = 'primary'
}) => {
    const content = (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                p: 4,
            }}
        >
            <CircularProgress size={size} color={color} />
            {message && (
                <Typography variant="body2" color="text.secondary">
                    {message}
                </Typography>
            )}
        </Box>
    )

    if (fullScreen) {
        return (
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'background.default',
                    zIndex: 9999,
                }}
            >
                {content}
            </Box>
        )
    }

    return content
}

/**
 * Loading Skeleton for cards
 */
export const LoadingSkeleton = ({ count = 3 }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {Array.from({ length: count }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        height: 80,
                        bgcolor: 'action.hover',
                        borderRadius: 2,
                        animation: 'pulse 2s ease-in-out infinite',
                    }}
                />
            ))}
        </Box>
    )
}

/**
 * Loading Overlay
 */
export const LoadingOverlay = ({ open, message = 'Processing...' }) => {
    if (!open) return null

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'rgba(255, 255, 255, 0.8)',
                zIndex: 10,
                borderRadius: 'inherit',
            }}
        >
            <Loading message={message} />
        </Box>
    )
}

export default Loading
